import React, { useContext } from 'react'
import AppContext from 'context'
import colors from 'utils/colors'

export default ({ children }) => {
  const { state, save } = useContext(AppContext)
  const { loading } = state

  const handleSave = async e => {
    e.preventDefault()
    save()
  }

  return (
    <button 
      onClick={handleSave} 
      style={{backgroundColor: colors.green, opacity: loading ? .5 : 1}} 
      disabled={loading}
      type="button" 
    >
      { loading ? (
        <>Saving...</>
      ) : children }
    </button>
  )
}